import { computePeaks } from "@xinghai/ui";

/** Bar count that reads well on a 375px phone without being noisy. */
export const DEFAULT_BAR_COUNT = 180;

/** Downsample captured PCM into Waveform-ready peaks. */
export function peaksFromPcm(pcm: Float32Array, barCount = DEFAULT_BAR_COUNT): Float32Array {
  return computePeaks(pcm, barCount);
}

export { computePeaks };
